// extracted by mini-css-extract-plugin
module.exports = {"box":"_3XqlO","header":"_2dwfz","body":"_3YPlq","field":"OXWkO"};